<template>
  <div v-if="visible" class="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
    <div class="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg w-1/3">
      <h2 class="text-lg font-semibold mb-4 text-gray-900 dark:text-gray-100">Edit Category</h2>
      <input
        v-model="newCategory"
        type="text"
        class="mb-3 w-full border border-gray-300 dark:border-gray-600 rounded-md shadow-sm p-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-gray-100"
      />
      <div class="flex justify-end gap-4 mt-4">
        <button
          @click="closeModal"
          class="px-4 py-2 bg-gray-300 text-gray-700 rounded-md dark:bg-gray-700 dark:text-gray-300"
        >
          Cancel
        </button>
        <button
          @click="saveCategory"
          class="px-4 py-2 bg-blue-500 text-white rounded-md dark:bg-blue-600 dark:text-gray-100"
        >
          Save
        </button>
      </div>
    </div>
  </div>
</template>
  
<script>
  export default {
    props: {
      visible: {
        type: Boolean,
        required: true
      },
      originalCategory: {
        type: String,
        required: true
      },
    },
    data() {
      return {
        newCategory: this.originalCategory
      };
    },
    watch: {
      originalCategory(newVal) {
         // Update newCategory when originalCategory changes.
        this.newCategory = newVal;
      },
    },
    methods: {
      closeModal() {
        this.$emit('close');
      },
      saveCategory() {
         // Notify parent with the updated category.
        this.$emit('save', this.originalCategory, this.newCategory);
      },
    },
  };
</script>